export default __webpack_public_path__ + "static/media/Grizzly Mask.b5a9b183.jpg";